import { ImageWrap } from '@hhgtech/hhg-components/components'
import { AspectRatio, Box } from '@mantine/core'
import { useIntl } from 'react-intl'

import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'
import myImageLoader from 'imageLoader'
import { DEFAULT_IMG } from 'interfaces/constants'
import { DataAttributeKey, SpotlightSummary } from 'interfaces/types'

import {
  StyledButtonSpotlight,
  StyledCardWrapper,
  StyledSeemoreButton,
} from './index.styled'
export type Props = {
  spotlight: SpotlightSummary
  showSeeMore?: boolean
  cardsPerRow?: number
  index?: number
  className?: string
  tracking?: Record<DataAttributeKey, string | undefined>
  buttonSize?: 'small' | 'large'
}
const SpotlightCard = ({
  index,
  spotlight,
  showSeeMore = false,
  cardsPerRow,
  className,
  tracking,
  buttonSize = 'small',
}: Props) => {
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()

  const image = spotlight?.smallBanner || spotlight?.image || DEFAULT_IMG
  const buttonDisplay = spotlight?.buttonDisplay

  const linkProps = {
    href: spotlight.permalink,
    'data-cards-per-row': cardsPerRow,
    'data-event-category': 'Spotlight',
    'data-event-action': `Click ${index}`,
    'data-event-label': `https://${domainLocales[locale]}${spotlight.permalink}`,
    ...tracking,
  }
  return (
    <StyledCardWrapper className={className} {...linkProps}>
      <AspectRatio ratio={268 / 357}>
        <Box>
          {spotlight.isPremium && (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="premium"
            >
              <rect width="24" height="24" rx="12" fill="#FFF8E2" />
              <circle cx="12" cy="12" r="10" fill="#FE921D" />
              <path
                d="M12 6.375C11.8342 6.375 11.6753 6.44085 11.5581 6.55806C11.4408 6.67527 11.375 6.83424 11.375 7C11.3749 7.09952 11.3985 7.19763 11.4439 7.28616C11.4894 7.3747 11.5553 7.45111 11.6362 7.50903L9.71606 10.197L6.34204 9.07275C6.3636 9.00904 6.37473 8.94226 6.375 8.875C6.375 8.70924 6.30915 8.55027 6.19194 8.43306C6.07473 8.31585 5.91576 8.25 5.75 8.25C5.58424 8.25 5.42527 8.31585 5.30806 8.43306C5.19085 8.55027 5.125 8.70924 5.125 8.875C5.125 9.04076 5.19085 9.19973 5.30806 9.31694C5.42527 9.43415 5.58424 9.5 5.75 9.5C5.79561 9.49967 5.84105 9.49435 5.8855 9.48413L6.78271 13.521C6.90959 14.0929 7.41657 14.5 8.0022 14.5H15.9966C16.5822 14.5 17.0904 14.0929 17.2173 13.521L18.1145 9.48535C18.159 9.49516 18.2044 9.50007 18.25 9.5C18.4158 9.5 18.5747 9.43415 18.6919 9.31694C18.8092 9.19973 18.875 9.04076 18.875 8.875C18.875 8.70924 18.8092 8.55027 18.6919 8.43306C18.5747 8.31585 18.4158 8.25 18.25 8.25C18.0842 8.25 17.9253 8.31585 17.8081 8.43306C17.6908 8.55027 17.625 8.70924 17.625 8.875C17.6253 8.94226 17.6364 9.00904 17.658 9.07275L14.2839 10.197L12.3625 7.50781C12.4435 7.45014 12.5096 7.37399 12.5552 7.28567C12.6009 7.19735 12.6248 7.09942 12.625 7C12.625 6.83424 12.5592 6.67527 12.4419 6.55806C12.3247 6.44085 12.1658 6.375 12 6.375ZM7.625 15.75C7.28 15.75 7 16.03 7 16.375C7 16.72 7.28 17 7.625 17H16.375C16.72 17 17 16.72 17 16.375C17 16.03 16.72 15.75 16.375 15.75H7.625Z"
                fill="white"
              />
            </svg>
          )}
          <ImageWrap
            alt={spotlight.name}
            src={image}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'top',
            }}
            placeholderSrc={myImageLoader({
              src: image,
              width: 10,
              quality: 10,
            })}
          />
          {!!buttonDisplay && (
            <StyledButtonSpotlight
              buttonSize={buttonSize}
              {...linkProps}
              bgColor={buttonDisplay.button_background_color}
              textColor={buttonDisplay.button_text_color}
            >
              {buttonDisplay.button_label || ''}
            </StyledButtonSpotlight>
          )}
          {showSeeMore && (
            <StyledSeemoreButton data-cards-per-row={cardsPerRow}>
              {f({
                id: 'spotlightCard.learnmore',
                defaultMessage: 'Learn more',
              })}
            </StyledSeemoreButton>
          )}
        </Box>
      </AspectRatio>
    </StyledCardWrapper>
  )
}

export { SpotlightCard }
